import { EpimsBaseEntityDto } from './epim-base.dto';
export class SubSubGroupTypeCategoryDto extends EpimsBaseEntityDto {
  SubSubGroupTypeCategoryName: string;
  SubscriptionUserId: string;
  Version: number;
}
